import React, { useState, lazy } from 'react';
import ArrowLgButton from '../Global/ArrowLgButton';
import RichText from '../Global/RichText';
//@ts-ignore
import * as styles from './product-detail-highlight.module.css';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { ProductHighlight } from '../../templates/StructuredDataContext';
import { ProductDetailHighlightProps } from '.';
import { getMediaData } from '../Global/DataUtils';
import { getFluidImageData } from '../Global/DataUtils/gatsbyImageUtils';
import GatsbyImage from 'gatsby-image/withIEPolyfill';
import loadable from '@loadable/component';

const ReactPlayer = loadable(() => import('react-player'));

const ProductDetailHighlight: React.FC<ProductDetailHighlightProps> = (
    props
) => {
    const highlights = props.product_highlights.value;
    const [currentHighlight, setCurrentHighlight] = useState(0);
    const breakpoints = useBreakpoint();
    const arrowStrokeColor = '#f3660b';

    const handleClickNext = () => {
        if (currentHighlight === highlights.length - 1) {
            setCurrentHighlight(0);
        } else {
            const nextHighlight = currentHighlight + 1;
            setCurrentHighlight(nextHighlight);
        }
    };

    const handleClickPrev = () => {
        if (currentHighlight === 0) {
            const prevHighlight = highlights.length - 1;
            setCurrentHighlight(prevHighlight);
        } else {
            const prevHighlight = currentHighlight - 1;
            setCurrentHighlight(prevHighlight);
        }
    };

    const highlightClass =
        highlights.length === 1 ? styles.soloHighlight : styles.highlight;
    const wrapperClass = highlights.length === 1 ? undefined : styles.wrapper;

    const renderHighlight = (highlight: ProductHighlight, idx: number) => {
        if (breakpoints.l || idx === currentHighlight) {
            const selection =
                highlight.elements.content_selection?.value[0]?.codename;

            const image =
                selection !== 'video' && idx === 0
                    ? getFluidImageData(highlight.elements?.image)
                    : {
                          source: highlight.elements?.image?.value[0]?.elements
                              ?.file?.value[0]?.fluidShort,
                          alt:
                              getMediaData(highlight.elements?.image)
                                  ?.description ||
                              getMediaData(highlight.elements?.image)?.name,
                      };
            const video = highlight.elements.video_url;

            return (
                <div className={highlightClass} key={idx}>
                    {selection !== 'video' && image?.source && (
                        <GatsbyImage
                            //@ts-ignore
                            fluid={image.source}
                            alt={image.alt}
                            className={styles.highlightImage}
                        />
                    )}

                    {selection === 'video' && video && (
                        <div className={styles.highlightVideo}>
                            <ReactPlayer
                                playing={true}
                                width="100%"
                                height="100%"
                                previewTabIndex={1}
                                url={video.value}
                                muted={true}
                            />
                        </div>
                    )}

                    <div className={styles.highlightContent}>
                        {!breakpoints.l &&
                        highlights.length > 1 &&
                        idx === 1 ? (
                            <ArrowLgButton
                                direction="left"
                                handleClick={handleClickPrev}
                                strokeColor={arrowStrokeColor}
                                className={styles.prev}
                            />
                        ) : null}
                        <div className={styles.highlightDescription}>
                            {highlight.elements.highlight_description &&
                                RichText(
                                    highlight.elements.highlight_description
                                )}
                        </div>
                        {!breakpoints.l &&
                        highlights.length > 1 &&
                        idx === 0 ? (
                            <ArrowLgButton
                                direction="right"
                                handleClick={handleClickNext}
                                strokeColor={arrowStrokeColor}
                                className={styles.next}
                            />
                        ) : null}
                    </div>
                </div>
            );
        }
    };

    return (
        <section className={wrapperClass}>
            <div className={styles.highlights}>
                {highlights &&
                    highlights.map((highlight, idx) => {
                        return renderHighlight(highlight, idx);
                    })}
            </div>
        </section>
    );
};

export default ProductDetailHighlight;
